import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestFormPage.NetSuiteBillRequestForm', {
    toolbarText: 'Bill details',
    mandatoryFieldsError: 'Please fill all mandatory fields.',
    totalAmountExceedError: 'Total amount cannot exceed {maxValue}.',
    totalAmountLessZeroError: 'Total amount cannot be negative.',
    discountAmountExceedError: 'Discount amount cannot exceed {maxValue}.',
    discountAmountLessZeroError: 'Discount amount cannot be negative.',
    taxAmountExceedError: 'Tax amount cannot exceed {maxValue}.',
    exchangeRateError:
        'Exchange rate is missing. Either retry loading exchange rates from NetSuite or enter manual exchange rate.',
});
